import { useNavigate } from 'react-router-dom'
import { useState, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { setPin } from '../../../../store/user-onboarding'
import { PageContainer } from '../../../../components/page-container/page-container'
import { Pin } from '../../../../components/pin'
import { Button } from '../../../../components/button'
import { paths } from '../../../../router/paths'
import { onboardingText, onboardingStyles } from '../styles/onboarding-styles'

export const CreatePin = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [pinLocal, setPinLocal] = useState('')
  const [error, setError] = useState<string | null>(null)

  const isAllSame = (val: string) => val.length === 4 && /^([0-9])\1{3}$/.test(val)

  const isCommonPattern = (val: string) => [
    "1212", "1004", "2000", "6969", "1122", "1313", "2001", "1010", "2580", "0852"
  ].includes(val)


  // Sequências ascendentes diretas ou "circulares" (wrap em 0)
  const isSequentialAsc = (val: string) => {
    const ascBase = ['0123','1234','2345','3456','4567','5678','6789']
    const circular = ['7890','8901','9012']
    return ascBase.concat(circular).includes(val)
  }

  const isSequentialDesc = (val: string) => {
    const descBase = ['9876','8765','7654','6543','5432','4321','3210']
    const circular = ['2109', '1098', '0987']
    return descBase.concat(circular).includes(val)
  }

  const keyBoardPattern = (val: string) => ['2580', '0852', '1478', '3692'].includes(val)

  const handleChange = (value: string) => {
    const digits = value.replace(/\D/g, '').slice(0, 4)
    setPinLocal(digits)
    if (digits.length === 4) {
      if (isAllSame(digits)) {
        setError(onboardingText.createPin.invalidSame)
      } else if (isCommonPattern(digits)) {
        setError(onboardingText.createPin.invalidCommon)
      } else if (isSequentialAsc(digits) || isSequentialDesc(digits)) {
        setError(onboardingText.createPin.invalidSequential) 
      } else if (keyBoardPattern(digits)) {
        setError(onboardingText.createPin.invalidPattern)
      } else {
        setError(null)
      }
    } else if (error) {
      setError(null)
    }
  }

  const isInvalidPin = useMemo(() => {
    if (pinLocal.length !== 4) return true
    return isAllSame(pinLocal) || isSequentialAsc(pinLocal) || isSequentialDesc(pinLocal)
  }, [pinLocal])

  const handleContinue = () => {
    if (pinLocal.length !== 4) return
    dispatch(setPin(pinLocal))
    navigate(paths.user.confirmPin)
  }

  return (
    <PageContainer
      type="unauthenticated"
      footerClass='flex w-full flex-col items-center justify-between gap-12 px-8'
      footer={
        <div className="flex w-full flex-col py-12">
          <p className="px-8 pb-6 text-start text-sm font-normal text-[#736969]">
            *Este PIN será su contraseña asociada a su usario para ingresar a
            esta aplicación
          </p>
          {error && (
              <p className="px-8 pb-6 text-start text-sm font-normal text-[red]" role="alert">{error}</p>
            )}
          <div className="flex w-full justify-center">  
            <Button
              className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
              onClick={handleContinue}
              disabled={pinLocal.length !== 4 || !!error}>
              Continuar
            </Button>
          </div>
          <div className="flex w-full justify-center pt-4">  
            <Button
              variant="outlined"
              className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
              onClick={() => navigate(paths.user.createUser)}
            >
              Regresar
            </Button>
          </div>
        </div>
      }
    >
      <div className={onboardingStyles.headerBar}>
        <p className={onboardingStyles.headerTitle}>{onboardingText.createPin.header}</p>
      </div>
      <div className={onboardingStyles.pageWrapper}>
        <div className={onboardingStyles.section}>
          <p className={onboardingStyles.instruction}>{onboardingText.createPin.instruction}</p>
          <div className={onboardingStyles.pinWrapper}>
            <Pin onChange={handleChange} type='pin' />
          </div>
        </div>
      </div>
    </PageContainer>
  )
}
